module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-requests"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Reviewer Requests")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Here you can approve or refuse dentists requests to become a VeriTooth Reviewer ")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.reviewerRequestsLength > 0) ? _c('div', {
    key: "requests-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.reviewerRequests.results,
      "row-click": true
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-requests__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.reviewerRequestsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.reviewerRequestsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.reviewerRequests.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    }
  }) : _vm._e()], 1)], 1) : (_vm.reviewerRequestsLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No current requests")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78473c1a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerRequests.vue
// module id = 352
// module chunks = 0